import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";
import { standardReducer } from "@/store/utils.js";

const salesProductsReducer = createAsyncReducer({
  name: 'salesProducts',
  initialState: {
    records: {},
    loading: false,
    errorMessage: ''
  },
  reducers: (create) => ({
    loadAll: create.asyncThunk(
      async () => {
        return Fetch.get(Routes.ajax_sales_products_path());
      },
      standardReducer,
    ),
    loadOne: create.asyncThunk(
      async ({ id }) => {
        return Fetch.get(Routes.ajax_sales_product_path(id));
      },
      standardReducer
    )
  })
});

export default salesProductsReducer;